/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./normal-group-item.vue?vue&type=template&id=3a67bf12&scoped=true&"
import script from "./normal-group-item.vue?vue&type=script&lang=js&"
export * from "./normal-group-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67bf12",
  null
  
)

export default component.exports